import { AxiosPromise } from "axios";
import Service from "@core/services/common/Service";
import { FileServer } from "@core/plugins/axiosREST";

export class AvatarService extends Service {
  public static getAvatarId (params: FormData): AxiosPromise {
    return FileServer.post("", params);
  }
}
